import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';
import { auth, db } from '../../firebase';

import Spacer from '../../components/spacer';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './a.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';

import { truncateForLink } from '../../data';

export default function Pricing() {
  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          <div className={l.co}>
            <Spacer />
            <h1>Pricing</h1>

            <p>knowledge for development</p>

            <div></div>
          </div>
          <MyFooter />
        </div>
      </div>
    </>
  );
}
